export class LocaleService {
    public static get locale() {
        return 'en';
    }
}
